function createMarkup(string) {
	return {__html: string};
}

module.exports = {createMarkup}


// WEBPACK FOOTER //
// ./src/utils/library.js